import { useState, useEffect } from 'react';

const useResponsiveFontSize = () => {
  const [fontSize, setFontSize] = useState(14);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setFontSize(12);
      } else {
        setFontSize(14);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Set initial size

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return fontSize;
};

export default useResponsiveFontSize; 